import React from 'react'
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router';

import PortfolioImage from './PortfolioImage';
import YoutubeVideoImage from '../YoutubeVideoImage';

export default class PortfolioItem extends React.Component {

    slug() {
        var str = this.props.item.title
            .toLowerCase()
            .replace(/ /g,'-')
            .replace(/[^\w-]+/g,'')
            .replace(/[-]+/g, '-')

        return str
    }

    linkToItem() {
        return '/portfolio#'+ this.slug()
    }

    renderPortfolioMedia (item) {
        if (item.videoId) {
            return (<YoutubeVideoImage videoId={item.videoId} />)
        } else if (item.imageUrl) {
            return (<PortfolioImage src={item.imageUrl} />)
        }
    }

    render () {
        return (
            <Row id={this.slug()} className="portfolio-item-row">
                <Col sm={6} md={7}>
                    <h4>
                        <Link to={this.linkToItem()}>
                            {this.props.item.title}
                        </Link>
                    </h4>
                    <h6>{this.props.item.client}</h6>
                    {this.props.item.description}
                </Col>
                <Col sm={6} md={5}>
                    {this.renderPortfolioMedia(this.props.item)}
                </Col>
            </Row>
        )
    }

}



// WEBPACK FOOTER //
// ./src/components/portfolio/PortfolioItem.js